import React from 'react';
const FacetsClearButton = ({ handleClearAll }) => {
  return (
    <a className="base-search-banner__facet-pills--clear" onClick={handleClearAll}>
      Clear all
    </a>
  );
};
export default FacetsClearButton;
